/**
 * Auto-generated default view spec for a form — the zero-config experience.
 * One ready-to-use long-format table per published form (architecture §5.1).
 */
import { nanoid } from 'nanoid'
import type { FormCatalog } from './column-catalog'
import type { DataViewSpec, ViewColumn } from '../types/data-view-spec'

export function buildAutoViewSpec(
  formId: string,
  catalog: FormCatalog,
  instanceType: 'single' | 'repeatable',
): DataViewSpec {
  const columns: ViewColumn[] = [
    { id: 'm_display', source: 'record_meta', key: 'display_id' },
    { id: 'm_status', source: 'record_meta', key: 'record_status' },
  ]
  if (instanceType === 'repeatable') {
    columns.push({ id: 'm_instance', source: 'record_meta', key: 'instance_index' })
  }
  // every catalogue field (file/image included — rendered as reference text); calc
  // fields are surfaced too since they compute client-side.
  for (const f of catalog.fields) {
    columns.push({ id: `f_${f.fieldKey}`, source: 'field', key: f.fieldKey, formId })
  }
  for (const c of catalog.calculated) {
    columns.push({ id: `c_${c.field_key}`, source: 'field', key: c.field_key, formId })
  }
  columns.push({ id: 'm_warn', source: 'record_meta', key: 'soft_warning_count' })

  return {
    base: { kind: 'form', formId },
    instanceStrategy: { mode: 'long' },
    columns,
    filters: [],
    sort: { key: 'display_id', dir: 'asc' },
    headerStrategy: 'label',
  }
}

/** Fresh ids for a spec being cloned into a user-saved view (avoid collisions). */
export function cloneSpec(spec: DataViewSpec): DataViewSpec {
  return {
    ...spec,
    columns: spec.columns.map((c) => ({ ...c, id: `${c.id}_${nanoid(4)}` })),
    filters: spec.filters.map((f) => ({ ...f, id: nanoid(6) })),
  }
}
